import { useSelector } from 'react-redux';
import { isPollingSocialPostCaptionsSelector } from 'redux/modules/download';
import { useSocialShareModal } from './SocialShareModalContext';
import { useSocialSharePlatform } from './SocialSharePlatforms';
import useSocialPostShareStatus from './SocialSharePlatforms/useSocialPostShareStatus';

export default function useIsBlockingActionInProgress(): boolean {
  const { isSchedulingPost } = useSocialShareModal();
  const { authenticating } = useSocialSharePlatform();
  const { isSharingPost } = useSocialPostShareStatus();

  const isPollingSocialPostCaptions = useSelector(
    isPollingSocialPostCaptionsSelector,
  );

  return (
    authenticating ||
    isSharingPost ||
    isSchedulingPost ||
    isPollingSocialPostCaptions
  );
}
